export default __webpack_public_path__ + "static/media/user.4567508c.svg";